import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Globals} from "../../sharedComponents/global-variables/globals";

@Component({
    selector: 'app-ivr-instructions',
    templateUrl: './ivr-instructions.component.html',
    styleUrls: ['./ivr-instructions.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IvrInstructionsComponent implements OnInit {

  constructor(public globals: Globals) {

  }

  ngOnInit(): void {
  }


}
